define(["exports", "moment"], function (_exports, _moment) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.timeCounter = void 0;
  _moment = _interopRequireDefault(_moment);

  var timeCounter = function timeCounter(initial, final) {
    var end = (0, _moment.default)(final ? final : (0, _moment.default)(), 'YYYY-MM-DD');
    var start = (0, _moment.default)(initial, 'YYYY-MM-DD');

    var duration = _moment.default.duration(start.diff(end));

    return duration.humanize();
  };

  _exports.timeCounter = timeCounter;
});